

export let colSiteName = {
                                    colId: 'siteName',
                                    headerName: 'Name',
                                    field: 'name',
                                    width: 100,
                                    sortable: true
                                };

export let colAddress = {
                                colId: 'address',
                                headerName: 'Address',
                                field: 'address',
                                width: 100,
                                sortable: true
                            };

export let colCity = {
                                colId: 'city',
                                headerName: 'City',
                                field: 'city',
                                width: 100,
                                sortable: true
                            };


export let colComments = {
                                colId: 'comments',
                                headerName: 'Comments',
                                field: 'comments',
                                width: 100,
                                sortable: true
                            };


export let colState = {
                                colId: 'state',
                                headerName: 'State',
                                field: 'state',
                                width: 100,
                                sortable: true
                            };

export let colZip = {
                                colId: 'zip',
                                headerName: 'Zip Code',
                                field: 'zip',
                                width: 100,
                                sortable: true
                            };

export let colBusUnitNum = {
                                colId: 'businessUnitNum',
                                headerName: 'Business Unit Number',
                                field: 'businessUnitNum',
                                width: 100,
                                sortable: true
                            };

export let colDistrict =   {
                            colId: 'district',
                            headerName: 'District',
                            field: 'district',
                            width: 100,
                            sortable: true
                        };


export let colDivision =   {
                            colId: 'division',
                            headerName: 'Division',
                            field: 'division',
                            width: 100,
                            sortable: true
                        };

export let colCounty = {
                        colId: 'county',
                        headerName: 'County',
                        field: 'county',
                        width: 100,
                        sortable: true
                    };

export let colFormerlyKnownAs =    {
                                    colId: 'fka',
                                    headerName: 'Formerly Known As',
                                    field: 'fka',
                                    width: 100,
                                    sortable: true
                                };


export let colSquareFootage =    {
                                    colId: 'squareFootage',
                                    headerName: 'Square Footage',
                                    field: 'squareFootage',
                                    width: 100,
                                    sortable: true
                                };


export let colProgram = {
                            colId: 'program',
                            headerName: 'Program',
                            field: 'program',
                            width: 100,
                            sortable: true
                        };

export let allColumns = [

    colSiteName,
    colAddress,
    colCity,
    colComments,
    colState,
    colZip,
    colBusUnitNum,
    colDistrict,
    colDivision,
    colCounty,
    colFormerlyKnownAs,
    colSquareFootage,
    colProgram
];




export let columnSelectList = [
    {
        value: colSiteName,
        viewValue: colSiteName.headerName
    },
    {
        value: colAddress,
        viewValue: colAddress.headerName
    },
    {
        value: colCity,
        viewValue: colCity.headerName
    },
    {
        value: colComments,
        viewValue: colComments.headerName
    },
    {
        value: colState,
        viewValue: colState.headerName
    },
    {
        value: colZip,
        viewValue: colZip.headerName
    },
    {
        value: colBusUnitNum,
        viewValue: colBusUnitNum.headerName
    },
    {
        value: colDistrict,
        viewValue: colDistrict.headerName
    },
    {
        value: colDivision,
        viewValue: colDivision.headerName
    },
    {
        value: colCounty,
        viewValue: colCounty.headerName
    },
    {
        value: colFormerlyKnownAs,
        viewValue: colFormerlyKnownAs.headerName
    },
    {
        value: colSquareFootage,
        viewValue: colSquareFootage.headerName
    },
    {
        value: colProgram,
        viewValue: colProgram.headerName
    }
];
